<template>
    <div class="dot-label-root" :class="{
        'dot-label-small': size === 'small',
        'dot-label-medium': size === 'medium',
        'dot-label-large': size === 'large',
    }">
        <i class="dot-label-icon" :class="icon" :style="iconStyle"></i>
        <span class="dot-label-text">{{ title }}</span>
    </div>
</template>

<script>
export default {
    name: "DotLabel",
    props: {
        title: {
            type: String,
            default: "",
        },
        color: {
            type: String,
            default: "primary",
        },
        icon: {
            type: String,
            default: "fa-solid fa-circle",
        },
        size: {
            type: String,
            default: "medium",
        },
    },
    computed: {
        iconStyle() {
            return {
                color: this.dotColor,
            };
        },
        dotColor() {
            const colorValue = (this.color || "").trim();
            const colors = {
                blue: "#007bff",
                primary: "#577696",
                secondary: "#FF8A1B",
                pagar: "var(--color-danger)",
                receber: "var(--color-success)",
                success: "#38a169",
                warning: "#f1bc31",
                info: "#4ab4e2",
                edit: "#7b7f83",
                danger: "#f0134d",
                disabled: "#bbbbbb",
            };

            const isHexWithHash = /^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(colorValue);
            const isHexWithoutHash = /^([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(colorValue);

            if (isHexWithHash) return colorValue;
            if (isHexWithoutHash) return `#${colorValue}`;

            return colors[colorValue] || colorValue;
        },
    },
};
</script>

<style scoped>
.dot-label-root {
    display: inline-flex;
    align-items: center;
    flex-wrap: nowrap;
    gap: 8px;
    border-radius: 999px;
    background: transparent;
    color: var(--text-primary);
    line-height: 1;
}

.dot-label-icon {
    font-size: 10px;
    line-height: 1;
    flex-shrink: 0;
}

.dot-label-text {
    display: inline-block;
    white-space: nowrap;
    color: var(--text-primary);
    font-size: 13px;
    font-weight: 500;
}

.dot-label-small {
    padding-top: 1px;
}

.dot-label-medium {
    padding-top: 2px;
}

.dot-label-large {
    padding-top: 4px;
}

.dot-label-small .dot-label-icon {
    font-size: 8px;
}

.dot-label-small .dot-label-text {
    font-size: 12px;
}

.dot-label-large .dot-label-icon {
    font-size: 12px;
}

.dot-label-large .dot-label-text {
    font-size: 14px;
}
</style>
